import React ,{useState, useEffect} from 'react';
export default function Home(){
    const [content,setContent] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    // content table has just a title, textKey, image and large text body for general purpose articles
    // need to filter on textKey for the exact article to retrieve
    const cUrl = "https://cms.lizakhan.com/items/content?filter[textKey][_eq]=introLKC"


        useEffect(()=>{
	fetch(cUrl).then(res => res.json()).then(result => {
	    setLoading(true);
	    console.log(result.data);
	    setContent(result.data);
	}).catch(error =>{
	    setLoading(true);
	    setError(error);
	})
    }, []);

    
    if(error){
	return <div> Error: {error}</div>;
    } else if(!loading){
	return <div>Loading ...</div>;
    } else{
	return(<main>		   
		   <div className="container px-4 py-5">
		       {content &&  content.map(item =>
			   <div className="container my-5">
			       <div className="row align-items-center g-5 py-5 banner-bg rounded-3 border shadow-lg">
				   <div className="col">
				       <div className="row banner-space">
					   &nbsp;
				       </div>
				       <div className="row bg-white-transp rounded-3 shadow-lg">
					   <div className="col">
					       <h1 className="display-6 fw-bold text-body-emphasis lh-1 mb-3">{item.title}</h1>
					       <p style={{textAlign: 'justify'}} className="lead" dangerouslySetInnerHTML={{ __html: item.body }} >
					       </p>
					   </div>
				       </div>
				   </div>
			       </div>
			   </div>
		       )}			       
		   </div>
		   
	       </main>)
    }
}
